// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

const application = Application.start()
const controllers = import.meta.globEager('./**/*_controller.js')
registerControllers(application, controllers)

// Override the Stimulus logger's "warn" option so we are notified for deprecated data-target usage
application.logger.warn = function(message) {
  message = 'Stimulus Warning: ' + message
  if (typeof(airbrake) != 'undefined') {
    airbrake.notify({ error: message })
  } else {
    console.error(message)
  }
}
